import React, { useState, useEffect, useContext} from 'react';
import MUIDataTable from 'mui-datatables';
import { Link as RouterLink} from 'react-router-dom';
import 'dayjs/locale/pt-br';
import dayjs from 'dayjs';

import {
  TableCell,
  TableFooter,
  TableRow,
  makeStyles
} from "@material-ui/core";

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// material
import {
    Stack,
    Alert,
    Button,
    Container,
    Typography,
    MenuItem,  
    ListItemIcon, 
    ListItemText,
    AlertTitle,
    TextField,
    Avatar,
    Autocomplete
  } from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';

import {api, 
        reiniciarToken, 
        consultaVendasAvulsa, 
        excluirVendasMesa, 
        cadastrarVendas, 
        finalizaVendasAvulsa, 
        consClienteConsumidorPadrao, 
        atualizarEstoqueProduto, 
        atualizarQuantidadeItens,
        consultaClientes, 
        consultaFornecedores} from '../../services/api';
// context
import { AuthContext } from '../../contexts/auth';  

import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import { fFormataDinheiro, fFormataDinheiroSemCifra } from '../../utils/formatNumber';

import CadVendaForms from '../FormsTemplates/VendaComercio/CadastroVendaAvulsaForms';

// utils
import { fDateFormatCalendario } from '../../utils/formatTime';
import produtoPadrao from '../../images/produto_padrao.jpg';



export default function VendaAvulsa() {

  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);
  const [qtdeItens, setQtdeItens] = useState(0);
  const [dataVenda, setDataVenda] = useState( dayjs() );
  const [clientes, setListCliente] = useState([]);
  const [fornecedores, setListFornecedor] = useState([]);
  const [cliente, setCliente] = useState([]);
  const [fornecedor, setFornecedor] = useState([]);
  const [formaPagamento, setFormaPagamento] = useState(1);

  let sumValorVenda;

  const getVendas = async () => {
    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const responseCliente = await consultaClientes();

    if(responseCliente.erro === true) {
      if (responseCliente.mensagem === 'O Token é inválido!' || responseCliente.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      responseCliente.data.forEach((valores) => {
        setListCliente(clientes => [...clientes, {id_cliente: valores.id_cliente, nome: valores.nome}])
      }); 
    };

    const responseFornecedor = await consultaFornecedores();

    if(responseFornecedor.erro === true) {
      if (responseFornecedor.mensagem === 'O Token é inválido!' || responseFornecedor.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      responseFornecedor.data.forEach((valores) => {
        setListFornecedor(fornecedores => [...fornecedores, {id_fornecedor: valores.id_fornecedor, nome_fantasia: valores.nome_fantasia}])
      });
    };

    const response = await consultaVendasAvulsa(localStorage.getItem(['usuario']));
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      response.data.forEach((valores) => {
        setData(dados => [...dados, {id_item_venda: valores.id_item_venda, 
                                     produto: valores.produto,
                                     qtde_venda: valores.qtde_venda,
                                     valor_venda: valores.valor_venda,
                                     valor_venda_formatado: fFormataDinheiro(valores.valor_venda),
                                     preco_custo: valores.preco_custo,
                                     url: valores.url
                                    }]);                   
      });
    }; 
  }

  useEffect(() => {
    getVendas();
  },[])  

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  }) 
  
  
  const excluirVenda = async (id) => {
    const response = await excluirVendasMesa(id);
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      setData([]);
      getVendas();
    }; 
  } 

  const atualizarQuantidade = async (id, dados, tipoOperacao) => {
    
    const body = {qtde_venda: dados.qtde_venda,
                  quantidade: qtdeItens,
                  valor_venda: dados.preco_custo,
                  tipo_operacao: tipoOperacao}
    
    const response = await atualizarQuantidadeItens(id, body);
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      setData([]);
      setQtdeItens(0);
      getVendas();
    }; 
  }

  const finalizarVenda = async () =>{
    
    const responseClientePadrao = await consClienteConsumidorPadrao();

    if(responseClientePadrao.erro === true) {
      if (responseClientePadrao.mensagem === 'O Token é inválido!'){
          logout();
      }else {
          setStatus({
            type: "erro",
            mensagem: responseClientePadrao.mensagem
          })
      }
    }else {
      const json = {data_venda: dataVenda,
                    id_cliente: cliente.id_cliente ? cliente.id_cliente : responseClientePadrao.data[0].id_cliente,
                    id_fornecedor: fornecedor.id_fornecedor ? fornecedor.id_fornecedor : 1,
                    qtde_venda: 1,
                    valor_venda: sumValorVenda,
                    usuario: localStorage.getItem(['usuario']),
                    id_empresa: localStorage.getItem(['id_empresa']),
                    forma_pagamento: formaPagamento};


      const response = await cadastrarVendas(json);

      if(response.erro === true) {
        if (response.mensagem === 'O Token é inválido!'){
            logout();
        }else {
            setStatus({
              type: "erro",
              mensagem: response.mensagem
            })
        }
      }else {
          const responseVenda = await consultaVendasAvulsa(localStorage.getItem(['usuario']));
          
          if(responseVenda.erro === true) {
            if (responseVenda.mensagem === 'O Token é inválido!' || responseVenda.mensagem === 'Acesso negado!'){
              logout();
            }
          }else {
            responseVenda.data.forEach((valores) => {
              atualizarEstoqueProduto(valores.codigo_produto, {qtde_estoque: valores.qtde_estoque, qtde_venda: valores.qtde_venda});             
            });
          }; 

          const response1 = await finalizaVendasAvulsa(response.data.id_venda, sumValorVenda, localStorage.getItem(['usuario']));

          if(response1.erro === true) {
            if (response1.mensagem === 'O Token é inválido!'){
                logout();
            }else {
                setStatus({
                  type: "erro",
                  mensagem: response1.mensagem
                })
            }
          }else {
            setStatus({
              type: "success",
              mensagem: "Venda Finalizada com sucesso!"
            })
            setData([]);
            getVendas();
          };            
      };
    };
  }

  const columns = [{name: "Ação",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <MenuItem onClick={() => excluirVenda(dados[dataIndex].id_item_venda)} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Excluir" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>
                          </> 
                        );
                      }
                    }
                  },
                  {name: "",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
                              <MenuItem onClick={() => atualizarQuantidade(dados[dataIndex].id_item_venda, dados[dataIndex], "subtrair")} sx={{ color: 'text.secondary' }}>
                                <ListItemIcon>
                                    <Iconify icon="ic:baseline-remove-circle" width={24} height={24} />
                                </ListItemIcon>
                              </MenuItem>
                              <TextField
                                size="small"
                                style = {{width: 50}}
                                value={qtdeItens}
                                onChange={(ev) => {
                                   setQtdeItens(ev.target.value)
                                }}
                              />
                              <MenuItem onClick={() => atualizarQuantidade(dados[dataIndex].id_item_venda, dados[dataIndex], "somar")} sx={{ color: 'text.secondary' }}>
                                <ListItemIcon>
                                    <Iconify icon="material-symbols:add-circle-rounded" width={24} height={24} />
                                </ListItemIcon>
                              </MenuItem>
                            </Stack>
                          </> 
                        );
                      }
                    }
                   } 
                  ,{name: "",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <Avatar src={dados[dataIndex].url ? dados[dataIndex].url : produtoPadrao} alt="imagemProduto" sx={{ width: 100, height: 100 }} />
                          </> 
                        );
                    }
                    }
                   } 
                  ,{name:"produto", label: "Produto"}
                  ,{name:"qtde_venda", label: "Qtde Venda"}
                  ,{name:"valor_venda_formatado", label: "Valor Venda"}
                  ];

  const useStyles = makeStyles((theme) => ({
    footerCell: {
        backgroundColor: "#cccccc",
        borderBottom: "none",
        color: "black",
        fontSize: 14,
        fontWeight: 'bold'
      }
  }));

  const classes  = useStyles();

  const options = {
    filterType: "dropdown",
    tableBodyHeight: "100%",
    selectableRows: "none",
    responsive: "standard",
    selectToolbarPlacement: "none",
    download: 'false',
    viewColumns: 'false',
    customTableBodyFooterRender: (opts) => {
        
        sumValorVenda = dados
          .reduce((total, item) => {
            return (total +  item.valor_venda);
        }, 0);

        return (
          <>
            {dados.length > 0 && (
              <TableFooter className={classes.footerCell}>
                <TableRow>
                  {opts.selectableRows !== 'none' ? <TableCell className={classes.footerCell} /> : null}
                  {opts.columns.map((col, index) => {
                    if (col.display === "true") {
                      if (col.name === "qtde_venda") {
                        return (
                          <TableCell key={index} className={classes.footerCell}>
                            TOTAL
                          </TableCell>
                        );
                      }if (col.name === "valor_venda_formatado") {
                        return (
                          <TableCell key={index} className={classes.footerCell}>
                            {fFormataDinheiro(sumValorVenda)}
                          </TableCell>
                        );
                      }  
                      if (col.name !== "qtde_venda" && col.name !== "valor_venda_formatado") {
                        return <TableCell key={index} className={classes.footerCell}/>
                      };
                    }
                    return <TableCell key={index} className={classes.footerCell}/>;
                    })
                  }
                </TableRow>
              </TableFooter>
            )}
          </>
        );
    }
  };             
                    
  return (
    <Page title="Venda">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Cadastro de Venda
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained"  color="neutral" component={RouterLink} to="/venda/consultar" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
              Voltar
            </Button>
          </ThemeProvider>
        </Stack>
        
        <Stack mb={2} spacing={10}>
          <CadVendaForms/>
        </Stack>

        <Stack spacing={3}>
          {status.type === 'erro' ? <Alert severity="error"><AlertTitle>Erro</AlertTitle>{status.mensagem}</Alert> : ""}
          {status.type === 'success' ? <Alert severity="success"><AlertTitle>Sucesso</AlertTitle>{status.mensagem}</Alert> : ""}
        </Stack > 

        <Stack mb={2} spacing={10}>
          <MUIDataTable
              data={Object.values(dados)}
              columns={columns}  
              options={options} 
          />
        </Stack>

        <Stack mb={2} direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs} locale="pt-br" >
            <DatePicker
              label="Data Venda"
              value={dataVenda}
              onChange={(value) => {
                setDataVenda(value); 
              }}
              renderInput={(params) => <TextField {...params} fullWidth/>}
            />
          </LocalizationProvider>
          <Autocomplete
              getOptionLabel={(resultado) => resultado.nome}
              options={clientes}
              fullWidth
              onChange={(e, value) => { 
                setCliente({id_cliente: value.id_cliente, nome: value.nome}) 
              }}
              renderInput={(params) => (<TextField {...params} 
                                          label="Cliente" 
                                          fullWidth
                                          value={cliente}
                                          />
                                        )}
              isOptionEqualToValue={(option, value) => option.id_cliente === value.id_cliente}
          />
          <Autocomplete
              getOptionLabel={(resultado) => resultado.nome_fantasia}
              options={fornecedores}
              fullWidth
              onChange={(e, value) => { 
                setFornecedor({id_fornecedor: value.id_fornecedor, nome_fantasia: value.nome_fantasia}) 
              }}
              renderInput={(params) => (<TextField {...params} 
                                          label="Fornecedor" 
                                          fullWidth
                                          value={fornecedor}
                                          />
                                        )}
              isOptionEqualToValue={(option, value) => option.id_fornecedor === value.id_fornecedor}
          />
          <TextField 
              select
              fullWidth
              label="Forma de Pagamento"
              value={formaPagamento}
              onChange={(ev) => {
                setFormaPagamento(ev.target.value)
              }}
            >
              <MenuItem value ="1">Dinheiro</MenuItem>
              <MenuItem value ="2">PIX</MenuItem> 
              <MenuItem value ="3">Cartão de Crédito</MenuItem>
              <MenuItem value ="4">Cartão de Débito</MenuItem>
          </TextField>
        </Stack>

        <Stack mb={2}>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" onClick={finalizarVenda}>
                Finalizar Venda
            </Button>
          </ThemeProvider>
        </Stack>
      </Container>  
    </Page>  
  );
}
